import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-start-page',
  templateUrl: './start-page.component.html',
  styleUrls: ['./start-page.component.css']
})
export class StartPageComponent implements OnInit {

  // Passed in module number
  @Input() moduleNumber!: number;

  // Emit when the quiz is started
  @Output() quizStart: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  // Start quiz
  startQuiz() {
    this.quizStart.emit(true);
  }
}
